<template>
    <div>
        <loader-component v-if="isSendingDataToServer"></loader-component>
        <loader-component v-if="showLoader"></loader-component>
        <div>
            <selected-cart-modal></selected-cart-modal>
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar3-component></navbar3-component>
                </header>
                <!-- header -->
                <main class="search-page default">
                    <div class="container">
                        <div class="row">
                            <aside class="sidebar-page col-12 col-sm-12 col-md-12 col-lg-12">

                                <div class="span16" v-if="groups.length> 0">
                                    <div class="mainbox-container clearfix main-content-block main-offset">
                                        <p class="mainbox-title"><span>{{topGroupName}}</span>   <a target="_blank" class="btn-link-border cataolg" v-if="topGroupCatalog != null" :href="topGroupCatalog">دانلود کاتالوگ </a></p>
                                        <div class="mainbox-body">
                                            <h2 style="margin-bottom:0;" id="subcategories" class="cm-external-click hand" data-ca-scroll="subcategories">
                                                <i class="fa fa-list"></i>  {{topGroupName}}
                                            </h2>
                                            <hr style="margin-bottom:5px">


                                            <div class="d-block d-sm-none widget-product">
                                                <div class="product-carousel-2 owl-carousel owl-theme">
                                                    <div class="item filter-subGroup" v-for="(group,index) in groups">
                                                        <router-link :title="group.Title" :to="{ name: 'filter' , query: { GroupId: group.Id , GroupName: group.Title.replace(/\s+/g, '-') }}">
                                                            <img class="pict loaded img-fluid"
                                                                 @error="imageLoadOnError"
                                                                 :src="group.IconPath"
                                                                 :alt="group.Title"
                                                                 :title="group.Title" width="150" height="150">
                                                            <strong>{{group.Title}}</strong>
                                                        </router-link>
                                                        <br />
                                                        <a target="_blank" class="btn-link-border cataolg" v-if="group.Catalog != ''" :href="group.Catalog">دانلود کاتالوگ </a>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-none d-sm-block">
                                                <div id="content_subcategories" class="wysiwyg-content">
                                                    <div class="subcategories">
                                                        <div class="row">

                                                            <div class="col-md-3 col-sm-6 col-12 m-b--15 c--enter"
                                                                 v-for="(group, index) in visibleGroups"
                                                                 :key="group.Id">
                                                                <router-link class="wh-100" :title="group.Title"
                                                                             :to="{ name: 'filter', query: { GroupId: group.Id, GroupName: group.Title.replace(/\s+/g, '-') } }">
                                                                    <img class="pict pict-gr loaded img-fluid"
                                                                         @error="imageLoadOnError"
                                                                         :src="group.IconPath"
                                                                         :alt="group.Title"
                                                                         :title="group.Title">
                                                                    <!--<span style="padding:7px">{{ group.Title }}</span>-->
                                                                </router-link>
                                                                <br />
                                                                <div class="cataolg--g">
                                                                    <a target="_blank"
                                                                       class="btn-link-border cataolg "
                                                                       v-show="group.Catalog"
                                                                       :href="group.Catalog">
                                                                        دانلود کاتالوگ
                                                                    </a>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <!-- دکمه نمایش بیشتر/بستن -->
                                                        <div class="text-center mt-3" v-if="groups.length > initialCount">
                                                            <button style="background-color: #8e1717;margin-bottom:15px" class="btn btn-primary"
                                                                    @click="toggleShowMore">
                                                                {{ isExpanded ? "بستن" : "نمایش بیشتر" }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>




                                <div class="span16" v-if="subGroups.length> 0 && isShowListSubGroup">
                                    <div class="mainbox-container clearfix main-content-block main-offset">
                                        <p class="mainbox-title"><span>{{groupName}}</span>   </p>
                                        <div class="mainbox-body">
                                            <h2 style="margin-bottom:0;" id="subcategories" class="cm-external-click hand" data-ca-scroll="subcategories">
                                                <i class="fa fa-list"></i> زیرگروه  {{groupName}}
                                            </h2>
                                            <hr style="margin-bottom:5px">


                                            <div class="d-block d-sm-none widget-product">
                                                <div class="product-carousel-2 owl-carousel owl-theme">
                                                    <div class="item filter-subGroup" v-for="(subGroup,index) in subGroups">
                                                        <router-link :title="subGroup.Title" :to="{ name: 'filter' , query: { SubGroupId: subGroup.Id , SubGroupName: subGroup.Title.replace(/\s+/g, '-') }}">
                                                            <img class="pict loaded img-fluid"
                                                                 @error="imageLoadOnError"
                                                                 :src="subGroup.SubIconPath"
                                                                 :alt="subGroup.Title"
                                                                 :title="subGroup.Title" width="150" height="150">
                                                            <strong>{{subGroup.Title}}</strong>
                                                        </router-link>
                                                        <br />
                                                        <a target="_blank" class="btn-link-border cataolg" v-if="subGroup.Catalog != ''" :href="subGroup.Catalog">دانلود کاتالوگ </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="d-none d-sm-block">
                                                <div id="content_subcategories" class="wysiwyg-content">
                                                    <div class="subcategories">
                                                        <div class="row">
                                                            <div class="col-md-3 col-sm-6 col-12 m-b--15 c--enter"
                                                                 v-for="subGroup in subGroups">
                                                                <router-link class="wh-100" :title="subGroup.Title" :to="{ name: 'filter' , query: { SubGroupId: subGroup.Id , SubGroupName: subGroup.Title.replace(/\s+/g, '-') }}">
                                                                    <img class="pict loaded img-fluid"
                                                                         @error="imageLoadOnError"
                                                                         :src="subGroup.SubIconPath"
                                                                         :alt="subGroup.Title"
                                                                         :title="subGroup.Title" width="150" height="150">
                                                                    <!--<strong>{{subGroup.Title}}</strong>-->
                                                                </router-link>
                                                                <br />
                                                                <div class="cataolg--g">
                                                                    <a target="_blank" class="btn-link-border cataolg" v-if="subGroup.Catalog != ''" :href="subGroup.Catalog">دانلود کاتالوگ </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>








                                <div class="span16" v-if="categories.length> 0 && isShowListSubGroup">
                                    <div class="mainbox-container clearfix main-content-block main-offset">
                                        <p class="mainbox-title"><span>{{subGroupName}}</span> </p>
                                        <div class="mainbox-body">
                                            <h2 style="margin-bottom:0;" id="subcategories" class="cm-external-click hand" data-ca-scroll="subcategories">
                                                <i class="fa fa-list"></i> دسته بندی  {{subGroupName}}
                                            </h2>
                                            <hr style="margin-bottom:5px">


                                            <div class="d-block d-sm-none widget-product">
                                                <div class="product-carousel-2 owl-carousel owl-theme">
                                                    <div class="item filter-subGroup" v-for="(category,index) in categories">
                                                        <router-link :title="category.Title" :to="{name: 'filter' , query:{ CategoryId: category.Id , CategoryName: category.Title , SubGroupName: category.SubGroupName.replace(/\s+/g, '-') , SubGroupId: category.SubGroupId}}">
                                                            <img class="pict loaded img-fluid"
                                                                 @error="imageLoadOnError"
                                                                 :src="category.SubIconPath"
                                                                 :alt="category.Title"
                                                                 :title="category.Title" width="150" height="150">
                                                            <strong>{{category.Title}}</strong>
                                                        </router-link>
                                                        <br />
                                                        <a target="_blank" class="btn-link-border cataolg" v-if="category.Catalog != ''" :href="category.Catalog">دانلود کاتالوگ </a>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="d-none d-sm-block">
                                                <div id="content_subcategories" class="wysiwyg-content">
                                                    <div class="subcategories">
                                                        <div class="row">
                                                            <div class="col-md-3 col-sm-6 col-12 m-b--15 c--enter"
                                                                 v-for="category in categories">
                                                                <router-link :title="category.Title" :to="{name: 'filter' , query:{ CategoryId: category.Id , CategoryName: category.Title  , SubGroupName: category.SubGroupName.replace(/\s+/g, '-') , SubGroupId: category.SubGroupId}}">
                                                                    <img class="pict loaded img-fluid"
                                                                         @error="imageLoadOnError"
                                                                         :src="category.SubIconPath"
                                                                         :alt="category.Title"
                                                                         :title="category.Title" width="150" height="150">
                                                                    <!--<strong>{{category.Title}}</strong>-->
                                                                </router-link>
                                                                <br />
                                                                <div class="cataolg--g">
                                                                    <a target="_blank" class="btn-link-border cataolg" v-if="category.Catalog != ''" :href="category.Catalog">دانلود کاتالوگ </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>



                            </aside>
                            <div id="fffff" style="padding-right:0;padding-left:0;" class="col-12 col-sm-12 col-md-12 col-lg-12  align-self-md-start" v-if="products.length > 0 || isSendingDataToServer">

                                <breadcrumb></breadcrumb>
                                <div class="listing default">
                                    <div class="listing-counter">{{ filteredCount }} محصول یافته شد</div>
                                    <order-by></order-by>
                                    <filterd-product-viewer></filterd-product-viewer>
                                    <paging-view></paging-view>
                                </div>
                            </div>
                            <div class="container text-center col-12 col-sm-12 col-md-12 order-md-2 align-self-md-start" v-else="">
                                <no-result-found></no-result-found>
                            </div>
                        </div>
                        <div class="row" v-if="description != null">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 ">
                                <div class="des-crip-tion">
                                    <div v-html="description">

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 ">
                                <questions :groupOrsubGroupId=this.groupOrsubGroupId ></questions>
                            </div>
                        </div>
                    </div>
                </main>

                <footer-component></footer-component>
                <!--<footer-fixnav-component></footer-fixnav-component>-->
            </div>
        </div>
    </div>
</template>


<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    import { initialSite } from "../../module/initialSite";
    import { httpPromise } from "../../module/httpUtility";
    import productBrands from "./productBrands.vue"
    import productGrouping from './productGrouping.vue';
    import noResultFound from './noResultFound.vue';
    import breadcrumb from './breadcrumb.vue'
    import searchInResult from './searchInResult';
    import questions from './questions.vue'
    import rangeSlider from './rangeSlider.vue'
    import paging from './paging.vue'
    import orderBy from './orderBy.vue'
    import filterdProductViewer from "./filterdProductViewer.vue";

    export default {
        data() {
            return {
                searchInResult: '',
                rangeSliderValues: { from: 0, to: 0, min: 0, max: 0 },
                orderBy: 0,
                groupOrsubGroupId: {},
                selectedBrands: [],
                filteredCount: 0,
                products: [],
                categoryId: 0,
                isAvalible: false,
                isSendingDataToServer: false,
                showLoader: false,
                groups: [],
                subGroups: [],
                categories: [],
                isShowListSubGroup: false,
                groupName: '',
                subGroupName: '',
                topGroupName: '',
                description: '',
                catalog: null,
                subgroupCatalog: null,
                topGroupCatalog: '',
                isExpanded: false, // وضعیت باز/بسته
                initialCount: 12,
            }
        },
        components: {
            'no-result-found': noResultFound,
            'breadcrumb': breadcrumb,
            'search-in-result': searchInResult,
            'range-slider': rangeSlider,
            'product-grouping': productGrouping,
            'paging-view': paging,
            'order-by': orderBy,
            'product-brands': productBrands,
            'questions': questions,
            'filterd-product-viewer': filterdProductViewer
        },
        computed: {
            visibleGroups() {
                return this.isExpanded ? this.groups : this.groups.slice(0, this.initialCount);
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
        },
        watch: {
            $route: function (to, from) {
                this.sendToServer();
                this.getDataSubGroup();
            },
            '$route.query': {
                immediate: true,
                deep: true,
                handler(newQuery, oldQuery) {
                    // تغییر عنوان صفحه
                    if (newQuery.GroupName !== undefined) {
                        document.title = newQuery.GroupName;
                    } else if (newQuery.SubGroupName !== undefined) {
                        document.title = newQuery.SubGroupName;
                    } else if (newQuery.TagName !== undefined) {
                        document.title = newQuery.TagName;
                    } else if (newQuery.SearchValue !== undefined) {
                        document.title = newQuery.SearchValue;
                    } else if (newQuery.BrandName !== undefined) {
                        document.title = newQuery.BrandName;
                    }
                    this.groupOrsubGroupId = this.$route.query.GroupId
                        ? { GroupId: this.$route.query.GroupId, IsGroup: true }
                        : this.$route.query.SubGroupId
                            ? { SubGroupId: this.$route.query.SubGroupId, IsGroup: false }
                            : null;
 
                    if (newQuery.SearchValue === '') {
                        document.title = 'فروشگاه اینترنتی ایران مارت ';
                    }

                    // تنظیم meta robots
                    const robotsMeta = $('meta[name="robots"]');
                    const shouldNoIndex = !IsNullOrEmptyString(newQuery.CategoryId) || !IsNullOrEmptyString(newQuery.BrandCode);

                    if (shouldNoIndex) {
                        if (robotsMeta.length) {
                            robotsMeta.attr("content", "noindex, follow");
                        } else {
                            $('head').append('<meta name="robots" content="noindex, follow">');
                        }
                    } else {
                        if (robotsMeta.length) {
                            robotsMeta.remove();
                        }
                    }

                }
            }
        },
        beforeMount: function () {

            var delegateFunction = this.getDataSubGroup;
            initialSite(this, delegateFunction);
            this.sendToServer();
        },
        mounted: function () {
            this.getDataSubGroup();

        },
        created() {
            filterEventBus.$on('createQueryStringParameter', this.createQueryStringParameter);
            // this.getDataSubGroup();
        },
        beforeDestroy() {
            filterEventBus.$off('createQueryStringParameter');
        },
        methods: {
            toggleShowMore() {
                this.isExpanded = !this.isExpanded;
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            getDataSubGroup() {
                this.groups = [];
                this.subGroups = [];
                this.categories = [];

                if (!IsNullOrEmptyString(this.$route.query.TopGroupId)) {
                    // فیلتر کردن برای پیدا کردن گروه بالا
                    var topGroup = this.$store.getters.readTopGroups.find(x => x.Id == this.$route.query.TopGroupId);

                    if (topGroup) {
                        this.topGroupName = topGroup.Title;
                        this.isShowListSubGroup = true;
                        this.topGroupCatalog = topGroup.Catalog;
                        // چک کردن تطابق آیدی
                        if (this.$route.query.TopGroupId == topGroup.Id) {
                            if (topGroup.GroupIds.length > 0) {
                                var ids = topGroup.GroupIds.split(',').map(id => parseInt(id, 10));
                                var group = this.$store.getters.readGroups.filter(x => ids.includes(x.Id));
                                for (var i = 0; i < group.length; i++) {
                                    this.groups.push({
                                        Id: group[i].Id,
                                        Title: group[i].Title,
                                        IconPath: group[i].GroupPicPath,
                                        Catalog: group[i].Catalog
                                    });
                                }
                            }

                        }
                    }
                }


                if (!IsNullOrEmptyString(this.$route.query.GroupId)) {

                    this.isShowListSubGroup = true;
                    this.groupName = IsNullOrEmptyString(this.$route.query.TitleUrl) ? this.$route.query.GroupName.replace('-', ' ') : this.$route.query.TitleUrl.replace('-', ' ');
                    if (this.$store.getters.readGroups == null)
                        return;
                    this.subGroups = [];
                    var group = this.$store.getters.readGroups.filter(x => x.Id == this.$route.query.GroupId)[0];
                    this.catalog = IsNullOrEmptyString(group.Catalog) ? null : group.Catalog;
                    //   console.log(JSON.stringify(group.Catalog));
                    for (var i = 0; i < group.SubGroups.length; i++) {
                        this.subGroups.push({ Id: group.SubGroups[i].Id, Title: group.SubGroups[i].Title, SubIconPath: group.SubGroups[i].SubIconPath, Catalog: group.SubGroups[i].Catalog });
                    }
                } else {
                    if (!IsNullOrEmptyString(this.$route.query.SubGroupId)) {
                        this.isShowListSubGroup = true;
                        this.subGroupName = this.$route.query.SubGroupName.replace('-', ' ');
                        if (this.$store.getters.readGroups == null)
                            return;
                        var list_subGroups = [];
                        for (var i = 0; i < this.$store.getters.readGroups.length; i++) {
                            for (var j = 0; j < this.$store.getters.readGroups[i].SubGroups.length; j++) {
                                var a = this.$store.getters.readGroups[i].SubGroups[j].Categories;
                                list_subGroups.push({
                                    Id: this.$store.getters.readGroups[i].SubGroups[j].Id,
                                    Title: IsNullOrEmptyString(this.$store.getters.readGroups[i].SubGroups[j].TitleUrl) ? this.$store.getters.readGroups[i].SubGroups[j].Title : this.$store.getters.readGroups[i].SubGroups[j].TitleUrl,
                                    Categories: a
                                });
                            }
                        }
                        var subGroup = list_subGroups.filter(x => x.Id == this.$route.query.SubGroupId)[0];

                        if (subGroup != null && subGroup.Categories != null) {
                            for (var i = 0; i < subGroup.Categories.length; i++) {
                                this.categories.push({ Id: subGroup.Categories[i].Id, Title: subGroup.Categories[i].Title, SubIconPath: subGroup.Categories[i].PicPath, SubGroupId: subGroup.Id, SubGroupName: subGroup.Title, Catalog: subGroup.Categories[i].Catalog });
                            }

                        }
                    } else {
                        this.isShowListSubGroup = false;
                    }

                }






            },
            isAvalibleEvent() {
                this.createQueryStringParameter();
            },
            createQueryStringParameter(page) {
                var query = {};
                var allowToAppendQueryString = true;
                if (!IsNullOrEmptyString(this.$route.query.TopGroupId)) {
                    query.TopGroupId = this.$route.query.TopGroupId;
                    allowToAppendQueryString = false;
                    if (!IsNullOrEmptyString(this.$route.query.TopGroupId)) {
                        query.TopGroupName = this.$route.query.TopGroupName;
                    }
                }
                if (!IsNullOrEmptyString(this.$route.query.SubGroupId)) {
                    query.SubGroupId = this.$route.query.SubGroupId;
                    allowToAppendQueryString = false;
                    if (!IsNullOrEmptyString(this.$route.query.SubGroupName)) {
                        query.SubGroupName = this.$route.query.SubGroupName;
                    }
                    if (!IsNullOrEmptyString(this.$route.query.CategoryId)) {
                        query.CategoryId = this.$route.query.CategoryId;
                        this.categoryId = this.$route.query.CategoryId;
                        if (!IsNullOrEmptyString(this.$route.query.CategoryName)) {
                            query.CategoryName = this.$route.query.CategoryName;
                        }
                    }
                }
                if (!IsNullOrEmptyString(this.$route.query.GroupId)) {
                    query.GroupId = this.$route.query.GroupId;
                    allowToAppendQueryString = false;
                    if (!IsNullOrEmptyString(this.$route.query.GroupName)) {
                        query.GroupName = this.$route.query.GroupName;
                    }
                }

                if (allowToAppendQueryString) {
                    if (!IsNullOrEmptyString(this.$route.query.TagId)) {
                        query.TagId = this.$route.query.TagId;
                        allowToAppendQueryString = false;
                        if (!IsNullOrEmptyString(this.$route.query.TagName)) {
                            query.TagName = this.$route.query.TagName;
                        }
                    }
                }
                if (allowToAppendQueryString) {
                    if (!IsNullOrEmptyString(this.$route.query.SearchValue)) {
                        query.SearchValue = this.$route.query.SearchValue;
                        allowToAppendQueryString = false;
                    }
                }
                //if (allowToAppendQueryString) {
                //    if (!IsNullOrEmptyString(this.$route.query.BrandCode)) {
                //        query.BrandCode = this.$route.query.BrandCode;
                //        allowToAppendQueryString = false;
                //        if (!IsNullOrEmptyString(this.$route.query.BrandName)) {
                //            query.BrandName = this.$route.query.BrandName;
                //        }
                //    }
                //}
                if (!IsNullOrEmptyString(this.searchInResult))
                    query.SearchInResult = this.searchInResult;

                if (!IsNullOrEmptyString(this.isAvalible) || this.isAvalible == true)
                    query.IsAvalible = this.isAvalible ? 'true' : '';

                if (!IsNullOrEmptyString(page))
                    query.Page = page;

                //if (this.selectedBrands != null && this.selectedBrands.length != 0)
                //    query.BrandIds = this.selectedBrands;

                //if (this.rangeSliderValues.from != this.rangeSliderValues.min || this.rangeSliderValues.to != this.rangeSliderValues.max) {
                //    query.FromPriceRange = this.rangeSliderValues.from;
                //    query.ToPriceRange = this.rangeSliderValues.to;
                //}

                if (this.orderBy != 0)
                    query.OrderBy = this.orderBy;

                this.$router.push({ name: 'filter', query: query });

            },
            sendToServer() {
                this.isSendingDataToServer = true;
                var data = Object.assign({}, this.$route.query);
                if (data.BrandIds != null)
                    data.BrandIds = data.BrandIds.join();
                httpPromise(this, '/v1/ProductManagement/Filters/Read', 'get', data,
                    response => {
                        this.filteredCount = response.data.Value.TotalCount;
                        this.products = response.data.Value.FilteredProducts;
                        this.isAvalible = this.$route.query.IsAvalible == 'true' ? true : false;
                        filterEventBus.$emit('productViewer', response.data.Value.FilteredProducts);
                        filterEventBus.$emit('initializSearchInResult', this.$route.query.SearchInResult);
                        filterEventBus.$emit('breadcrumbCreator');
                        filterEventBus.$emit('createRangeSlider', response.data.Value.FilteredPriceRange.MinPrice, response.data.Value.FilteredPriceRange.MaxPrice, this.$route.query.FromPriceRange, this.$route.query.ToPriceRange);
                        filterEventBus.$emit('createPaging', response.data.Value.TotalCount, response.data.Value.Page);
                        filterEventBus.$emit('initializOrderBy');
                        filterEventBus.$emit('initializIsAvalible');
                        filterEventBus.$emit('initializBrands', response.data.Value.FilteredBrands);
                        this.description = response.data.Value.MetaTags != null ? response.data.Value.MetaTags.Description : null;
                        $(function () {
                            if (response.data.Value.MetaTags != null) {
                                $('meta[name="description"]').attr("content", response.data.Value.MetaTags.MetaDescription);
                                $('meta[name="keywords"]').attr("content", response.data.Value.MetaTags.KeyWordsMetaTag);
                                //  $('link[rel="canonical"]').attr("href", response.data.Value.MetaTags.CanonicalHref);
                                $('meta[property="og:description"]').attr("content", response.data.Value.MetaTags.MetaDescription);
                            }
                            if (response.data.Value.MetaTags != null) {
                                if (response.data.Value.MetaTags.MetaTitle != null) {
                                    createPageTitle(response.data.Value.MetaTags.MetaTitle);
                                } else {
                                    createPageTitle("فروشگاه اینترنتی ایران مارت");
                                }
                            }

                        });

                        if (this.$route.query.Page >= 1)
                            this.scrollTopWithId();



                        this.isSendingDataToServer = false;
                    },
                    response => {
                        this.isSendingDataToServer = false;
                    }
                );
            },
            resetFilter() {
                this.orderBy = 0;
                this.selectedBrands = [];
                this.searchInResult = '';
                this.isAvalible = false;
                this.rangeSliderValues.min = this.rangeSliderValues.from;
                this.rangeSliderValues.max = this.rangeSliderValues.to;
                filterEventBus.$emit('resetRangeSlider');
                this.createQueryStringParameter();
            },
            scrollTopWithId() {
                $(function () {
                    $('html, body').animate({ scrollTop: $('#fffff').position().top }, 'slow');
                });
            },
            scrollTop() {
                $(function () {
                    $('html, body').animate({ scrollTop: 0 }, 800, 'easeInExpo');
                });
            }
        }
    }
</script>

<style scoped>
    .wh-100 {
        width: 100%;
        height: 100%;
    }

    .cataolg {
        font-size: 14px;
        margin-right: 15px;
    }

    .des-crip-tion {
        background-color: #fff;
        padding: 20px;
        margin-top: 15px;
        border-radius: 15px;
    }

    .filter-subGroup {
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .filter-subGroup strong {
            color: #06d;
            display: block;
            text-align: center;
        }

    .main-content-block {
        direction: rtl;
        background-color: #fff;
        padding: 0;
        margin: 15px auto;
        border-right: 0 solid transparent;
        box-shadow: 0 1px 4px rgba(0,0,0,0.1);
    }

    .mainbox-title, h1.mainbox-title {
        position: relative;
        margin-bottom: 8px;
        padding: 8px;
        border-bottom: 2px solid #efefef;
    }

        .mainbox-title span::after, h1.mainbox-title span::after {
            content: '';
            height: 2px;
            width: 12%;
            position: absolute;
            right: 8px;
            bottom: -2px;
            background-color: #1174e4;
        }

        .mainbox-title span, h1.mainbox-title span {
            color: #0b0000;
            font-weight: bold;
            font-size: 18px;
            line-height: normal;
        }

    .mainbox-title, p.mainbox-title {
        position: relative;
        margin-bottom: 8px;
        padding: 8px;
        border-bottom: 2px solid #efefef;
    }

        .mainbox-title span::after, p.mainbox-title span::after {
            content: '';
            height: 2px;
            width: 12%;
            position: absolute;
            right: 8px;
            bottom: -2px;
            background-color: #1174e4;
        }

        .mainbox-title span, p.mainbox-title span {
            color: #0b0000;
            font-weight: bold;
            font-size: 18px;
            line-height: normal;
        }

    h2#subcategories {
        font-family: inherit;
        margin-right: 10px;
        font-size: 120%;
        line-height: 2;
        color: #666;
    }

        h2#subcategories i {
            vertical-align: middle;
        }

    .hand {
        cursor: pointer;
    }

    .subcategories {
        float: none;
        padding: 0 10px;
        margin: 0 -6px 22px 0;
        direction: rtl;
    }

    .wysiwyg-content ul {
        margin: 5px 40px;
    }

    .subcategories ul {
        line-height: 18px;
        text-align: center;
    }

        .subcategories ul li.with-image {
            text-align: center;
        }

    .wysiwyg-content ul li {
        padding: 0;
        background-image: none;
        list-style-type: disc;
    }

    .subcategories ul li {
        display: inline-block;
        margin: 5px 5px;
        padding: 20px;
        box-shadow: 0px 1px 4px rgba(0,0,0,0.1);
    }

        .subcategories ul li a {
            display: inline-block;
        }

        .subcategories ul li.with-image img {
            display: block;
            margin: auto;
            padding: 15px;
        }

        .subcategories ul li a strong {
            color: #06d;
        }

    .product-carousel-2 .owl-item img {
        padding: 15px;
    }


    @media (max-width: 520px) {
        .owl-nav {
            display: block !important;
        }
    }














    ul li a {
        cursor: pointer;
    }

    /*.wrapper-child {
        position: fixed;
        background-color: rgba(140, 130, 128, 0.5) !important;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

        .wrapper-child .div-img {
            background-color: #fff;
        }

        .wrapper-child .div-img-p {
            text-align: center;
        }*/

    .btn-width {
        width: 100%;
    }

    .box-search {
        position: relative;
    }





    .form-account-agree {
        margin: 0;
    }

    .filter-box {
        position: relative;
    }

    .remove-box-filter {
        position: absolute;
        display: inline;
        left: 15px;
        top: 10px;
        cursor: pointer;
    }



    .close {
        cursor: pointer;
        float: left;
        vertical-align: middle !important;
        padding-right: 5px;
        padding-top: 3px;
    }

    .cataolg--g {
        height: 10px;
    }

    .filter-content ul li:hover .close {
        color: #333;
    }

    .m-b--15 {
        margin-bottom: 25px;
    }

    .pict-gr {
        border-radius: 7px;
    }

    .c--enter {
        text-align: center;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .sidebar-page .box {
            margin: 10px 0 10px;
        }
    }

    @media only screen and (min-width: 641px) and (max-width: 850px) {
        .product-box-img {
            height: auto !important;
        }

        .sidebar-page .box {
            margin: 10px 0 10px;
        }
    }
</style>